export default "__VITE_ASSET__ws7uozLu__"